<template>
  <div class="frame-content">
    <div style="width: 100%; height: 70px;">
      <HomeHeader></HomeHeader>
    </div>
    <div style="background-color: #F6F6F6;">
      <div style="width: 1180px;margin: auto">
        <div style="height: 25px"></div>
        <div v-loading="dataLoading" style="min-height: 270px;border-radius: 8px">
          <div class="top_hotel_info_box" v-show="!dataLoading">
            <div class="left">
              <div style="line-height: 20px">
                <span style="font-size: 18px;font-weight: bold">
                  {{ hotelInfo.nameCn }}
                </span>
                <span style="font-size: 14px">({{ hotelInfo.nameEn }})</span>
              </div>
              <div style="margin-top: 20px; margin-bottom: 10px" class="star_box">
                <div>
                  <div class="hotel_star" v-if="hotelInfo.star">
                    <el-rate v-model="hotelInfo.star" disabled></el-rate>
                    <span>{{ hotelInfo.starText }}</span>
                  </div>
                  <div class="hotel_star" v-if="!hotelInfo.star && hotelInfo.category">
                    <el-rate v-model="hotelInfo.category" disabled disabled-void-icon-class="iconfont icon-zuanshi"
                             :icon-classes="['iconfont icon-zuanshi', 'iconfont icon-zuanshi', 'iconfont icon-zuanshi', 'iconfont icon-zuanshi', 'iconfont icon-zuanshi']"></el-rate>
                    <span>{{ $commonUtil.getCategoryDesc(hotelInfo.category) }}</span>
                  </div>
                  <div class="hotel_star" v-if="!hotelInfo.star && !hotelInfo.category">
                    <el-rate :value="2" disabled></el-rate>
                    <span>{{ hotelInfo.starText }}</span>
                  </div>
                </div>
              </div>
              <div style="font-size: 14px;margin-top: 15px" class="text-over-hidden">
                <i class="iconfont icon-dizhi" style="color: #1e50f0"/>
                {{ $commonUtil.getCnStr(hotelInfo.addressCn, hotelInfo.addressEn) }}
              </div>
              <div style="display: flex;align-items: center;column-gap: 5px;margin-top: 15px"
                   v-if="hotelInfo.descArr && hotelInfo.descArr.length">
                <i class="iconfont icon-messagefill" style="color: #a35a76"/>
                <div class="hotel_desc_text">
                  <span v-if="hotelInfo.reDate && hotelInfo.reDate.split('-')[0] !== '1900'" v-html="hotelInfo.reDate ? `装修:` + hotelInfo.reDate : ''"></span>
                  <span v-html="hotelInfo.esDate ? `开业:` + hotelInfo.esDate : ''"></span>
                  <span v-for="(item, index) in hotelInfo.descArr" :key="index">{{ item }}</span>
                </div>
                <span style="margin-left: 10px;color: #1e50f0;cursor: pointer;"
                      @click="toPoint('hotel_desc_poriner')">{{ $t('hotel_detail.see_more') }}</span>
              </div>
              <div class="facility_box" v-if="hotelInfo.hotelFacilities">
                <div class="facility_item" v-for="(item, index) in showIconFacilities" :key="index"
                     v-show="showIcon(item)">
                  <i class="iconfont" :class="showIconMap[item]"/>
                  <div style="font-weight: 600;margin-top: 8px">{{ item }}</div>
                </div>
              </div>
            </div>
            <div class="right">
              <div class="main_img">
                <div :class="hotelInfo.images && hotelInfo.images[0] ? '' : 'image_box'">
                  <img @click="showImgDialog(hotelInfo.allImages, hotelInfo.images ? hotelInfo.images[0] : '', 1)"
                       :class="hotelInfo.images && hotelInfo.images[0] ? '' : 'noImg'"
                       :src="hotelInfo.images && hotelInfo.images[0] ? hotelInfo.images[0] : require('@/assets/newImage/noSwiperImg1.png')"
                       alt=""/>
                </div>
              </div>
              <div class="sub_img">
                <div style="height: calc(50% - 5px);margin-bottom: 10px;">
                  <div :class="hotelInfo.images && hotelInfo.images[1] ? '' : 'image_box'">
                    <img @click="showImgDialog(hotelInfo.allImages, hotelInfo.images ? hotelInfo.images[1] : '', 1)"
                         :class="hotelInfo.images && hotelInfo.images[1] ? '' : 'noImg'"
                         :src="hotelInfo.images && hotelInfo.images[1] ? hotelInfo.images[1] : require('@/assets/newImage/noSwiperImg1.png')"/>
                  </div>
                </div>
                <div style="height: calc(50% - 5px)">
                  <div :class="hotelInfo.images && hotelInfo.images[2] ? '' : 'image_box'">
                    <img @click="showImgDialog(hotelInfo.allImages, hotelInfo.images ? hotelInfo.images[2] : '', 1)"
                         :class="hotelInfo.images && hotelInfo.images[2] ? '' : 'noImg'"
                         :src="hotelInfo.images && hotelInfo.images[2] ? hotelInfo.images[2] : require('@/assets/newImage/noSwiperImg1.png')"/>
                  </div>
                </div>
                <span class="img_count" v-if="hotelInfo.images">共{{ hotelInfo.allImages.length }}张图片</span>
              </div>
            </div>
          </div>
        </div>
        <div class="new_form_box desc_point" ref="desc_point">
          <div>
            <div class="form_title">入住日期</div>
            <el-date-picker style="width: 260px" v-model="searchForm.checkIn" type="date" placeholder="选择日期"
                            value-format="yyyy-MM-dd" @change="changeDate" :picker-options="pickerOptions">
            </el-date-picker>
          </div>
          <div>
            <div class="form_title">离店日期</div>
            <el-date-picker ref="checkOutPicker" style="width: 260px" v-model="searchForm.checkOut" type="date"
                            placeholder="选择日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
            </el-date-picker>
          </div>
          <div>
            <div class="form_title">房间数</div>
            <el-select style="width: 100%" v-model="searchForm.room" placeholder="请选择">
              <el-option v-for="(item, i) in $finalData.SearchRoomCount" :key="i" :label="item + '间'" :value="item">
              </el-option>
            </el-select>
          </div>
          <div>
            <div class="form_title">入住人数</div>
            <el-select style="width: 100%" v-model="searchForm.adult" placeholder="请选择">
              <el-option v-for="(item, i) in $finalData.SearchAdultCount" :key="i" :label="item + '成人'"
                         :value="item">
              </el-option>
            </el-select>
          </div>
          <div style="margin-top: 19.5px;display: flex;align-items: center;column-gap: 8px">
            <b2b-button @click="onSearch()" style="height: 30px;line-height: 30px;width: 80px">更新</b2b-button>
            <span class="to_ctrip_btn" v-if="hotelInfo.ctripHotelCode" @click="toCtripPage">携程价</span>
          </div>
        </div>
        <div class="tab_box">
          <div class="tab_item" @click="toPoint('desc_point')">酒店预定</div>
          <div class="tab_item" @click="toPoint('hotel_desc_poriner')">酒店介绍</div>
          <div class="tab_item" @click="toPoint('policy_point')">酒店政策</div>
          <div class="tab_item" @click="toPoint('facility_point')">酒店设施</div>
        </div>
        <div>
          <div class="filter_box">
            <radio-span ref="radioSpan1" :sortList="roomNames" title="房型" @updateSelect="upSelectRoomName"
                        :width="150"></radio-span>
            <radio-span ref="radioSpan2" :sortList="bedTypeList" title="床型" @updateSelect="upSelectBedType"
                        :width="110"></radio-span>
            <radio-span ref="radioSpan3" :sortList="breakfastList" title="餐食" @updateSelect="upSelectBreakfastType"
                        :width="110"></radio-span>
            <radio-span ref="radioSpan4" :sortList="invoiceList" title="发票" @updateSelect="upSelectInvoiceType"
                        :width="110"></radio-span>
            <div class="cancel_btn" :class="isCancel ? 'active' : ''"
                 @click="isCancel = !isCancel">
              免费取消
            </div>
            <span class="clear_btn" @click="clearFilter">清空</span>
          </div>
          <div v-loading="dataLoading" :element-loading-background="$finalData.LoadingBgColorPart">
            <el-row class="menu-item-row">
              <template v-if="isLogin">
                <el-row
                  style="font-size: 14px;width: 1180px;margin: auto;border-bottom: 1px solid #eaecef;background-color: #fff;border-radius: 8px 8px 0 0"
                  :class="{ 'room-box-active': isSuckTop }">
                  <el-col class="room-item" :span="5" style="font-weight: 600;color: #4B5563">
                    {{ $t('hotel_detail.All_room_types') }}
                  </el-col>
                  <el-col class="room-item" :span="3"></el-col>
                  <el-col class="room-item" :span="3">{{ $t('hotel_detail.meals') }}</el-col>
                  <el-col class="room-item" :span="4">{{ $t('hotel_detail.Cancel_the_policy') }}</el-col>
                  <el-col class="room-item" :span="3">可住人数</el-col>
                  <el-col class="room-item" :span="3">{{ $t('hotel_detail.Average_price_room_night') }}</el-col>
                  <el-col class="room-item" :span="3">{{ $t('hotel_detail.book') }}</el-col>
                </el-row>
                <div class="rooms_content"
                     style="width: 1180px;border-top: 0;margin: auto auto 8px;display: flex;background-color: #FFFFFF;border-radius: 8px"
                     v-for="(item, i) in roomInfos" :key="i" :name="i">
                  <div class="room_box" @click="mouseEnter(item)">
                    <div :class="item.images && item.images[0] ? '' : 'room_image_box'" style="margin-bottom: 15px;"
                         class="room_img">
                      <img
                        :src="item.images && item.images[0] ? item.images[0] : require('@/assets/newImage/noSwiperRoom.png')"
                        width="100%"
                        style="width: 180px; height: 90px;cursor: pointer;object-fit: cover;border-radius: 8px"
                        :class="item.images && item.images[0] ? '' : 'noRoomImg'"/>
                      <div class="room_img_count" v-if="item.images && item.images.length">
                        共{{item.images.length }}张图片
                      </div>
                    </div>
                    <div class="room_name">
                      {{ $commonUtil.getCnStr(item.nameCn, item.nameEn) }}
                      <span v-if="!item.nameCn || !$commonUtil.getRegionIdBySHotelId(hotelInfo.hotelId)"
                            style="font-weight: normal;font-size: 11px">
                      {{item.nameEn }}
                    </span>
                    </div>
                    <div class="room_info_box">
                      <span v-if="item.bedInfo">{{ item.bedInfo }}</span>
                      <!--                    <span v-if="item.area">{{ item.area }}m²</span>-->
                      <!--                    <span v-if="item.windowType">{{ windowTypeMap[item.windowType] }}</span>-->
                      <!--                    <span v-if="item.floor">{{ item.floor }}</span>-->
                      <!--                    <span v-if="item.maxOccupancy">最多{{ item.maxOccupancy }}人</span>-->
                    </div>
                  </div>
                  <div class="room_right_box"
                       :class="item.rates && item.rates.length <= 2 ? 'is_center' : ''">
                    <div class="rate_box"
                         :style="{maxHeight: expandMap[item.roomId] ? item.rates && item.rates.length > 2 ? item.rates.length * 98 + 'px' : '181px' : '181px'}"
                         :class="expandMap[item.roomId] ? 'is_expand' : ''">
                      <div class="rate_item" v-for="(rate, i) in item.rates" :key="i">
                        <div>
                          <div v-if="item.roomId === -1" style="margin-bottom: 8px" class="other_room_name">
                            <el-tooltip class="item" effect="dark" placement="top">
                              <div slot="content">
                                <span>{{ rate.nameCn }}</span>
                                <span v-if="!rate.nameCn">{{ rate.nameEn }}</span>
                              </div>
                             <div style="overflow: hidden;text-overflow: ellipsis; white-space: nowrap;width: 140px">
                               <span>{{ rate.nameCn }}</span>
                               <span v-if="!rate.nameCn">{{ rate.nameEn }}</span>
                             </div>
                            </el-tooltip>
                          </div>
                          <div class="pkg_box" v-if="rate.pkgProductInfo" @click="showProductDialog(rate.pkgProductInfo)">
                            <i class="iconfont icon-liwuhuodong"/>
                            <span>含酒店套餐</span>
                            <i class="el-icon-arrow-right"/>
                          </div>
                          <div style="display:flex;column-gap: 10px;align-items: center;color: #2947ec;column-gap: 5px" v-if="item.roomId === -1">
                            <div style="display: flex;align-items: center;" v-if="rate.instantConfirm === 1">
                              <i class="iconfont icon-lijiqueren" style="font-size: 14px"/>
                              <span style="font-size: 14px;">立即确认</span>
                            </div>
                            <div style="display: flex;align-items: center;column-gap: 3px;">
                              <div style="font-size: 14px;display: flex;align-items: center;column-gap: 5px">
                                <svg v-if="rate.invoice === 1" t="1777268089850" class="icon" viewBox="0 0 1300 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3393" width="16" height="16"><path d="M1250.940541 392.994595c13.837838-2.767568 27.675676-11.07027 27.675675-33.210811V55.351351c-2.767568-27.675676-27.675676-55.351351-55.351351-55.351351H63.654054C35.978378 0 0 24.908108 0 58.118919v298.897297c0 19.372973 13.837838 35.978378 27.675676 35.978379 58.118919 13.837838 110.702703 60.886486 110.702702 135.61081 0 55.351351-44.281081 116.237838-110.702702 130.075676-13.837838 2.767568-27.675676 16.605405-27.675676 30.443243v273.98919C0 996.324324 24.908108 1024 60.886486 1024h1159.610811c30.443243 0 60.886486-24.908108 60.886487-60.886486v-276.756757c0-19.372973-11.07027-33.210811-30.443243-35.978379-55.351351-13.837838-99.632432-69.189189-99.632433-124.54054 0-60.886486 44.281081-121.772973 99.632433-132.843243z" fill="#FAC15C" p-id="3394"></path><path d="M1156.843243 293.362162V166.054054c-2.767568-22.140541-19.372973-44.281081-41.513513-44.281081h-940.972973c-22.140541 0-44.281081 19.372973-44.281081 41.513513v130.075676C199.264865 334.875676 265.686486 415.135135 265.686486 525.837838c0 94.097297-52.583784 168.821622-132.843243 224.172973v110.702703c0 24.908108 24.908108 41.513514 38.745946 41.513513h949.275676c22.140541 0 38.745946-19.372973 38.745946-44.281081v-107.935135c-69.189189-47.048649-127.308108-124.540541-127.308108-224.172973 0-83.027027 49.816216-182.659459 124.54054-232.475676z" fill="#FDFEFF" p-id="3395"></path><path d="M877.318919 481.556757c0-11.07027-8.302703-16.605405-19.372973-16.605406h-132.843243v-110.702702h116.237838c11.07027 0 24.908108-8.302703 24.908108-22.140541 0-11.07027-8.302703-24.908108-19.372973-24.908108h-96.864865l19.372973-38.745946c0-22.140541-35.978378-38.745946-49.816216-13.837838l-19.372973 52.583784h-110.702703l-19.372973-52.583784c-11.07027-30.443243-60.886486-16.605405-38.745946 16.605406l11.07027 33.21081h-85.794594c-13.837838 0-22.140541 8.302703-22.140541 24.908109 0 11.07027 8.302703 24.908108 19.372973 24.908108h113.47027v110.702702h-141.145946c-11.07027 0-22.140541 8.302703-22.14054 22.140541 0 11.07027 8.302703 22.140541 19.372973 22.14054h453.881081c8.302703 0 22.140541-11.07027 19.372973-27.675675h-19.372973z m-204.8-16.605406h-58.118919v-107.935135h58.118919v107.935135z m-132.843243-13.837837c11.07027-8.302703 2.767568-24.908108 0-33.210811l-19.372973-38.745946c-13.837838-19.372973-52.583784-8.302703-41.513514 13.837838L498.162162 442.810811c8.302703 16.605405 27.675676 13.837838 41.513514 8.302703z m251.848648-8.302703l33.210811-52.583784c5.535135-22.140541-27.675676-35.978378-41.513513-19.372973l-27.675676 55.351351c-5.535135 22.140541 27.675676 38.745946 35.978378 16.605406z m0 96.864865H506.464865c-13.837838 0-27.675676 11.07027-27.675676 24.908108V747.243243c0 24.908108 49.816216 38.745946 52.583784 0h238.010811c0 30.443243 52.583784 44.281081 52.583784 0v-182.659459c0-11.07027-11.07027-27.675676-30.443244-24.908108z m-22.14054 160.518919h-240.778379v-47.048649h240.778379v47.048649z m0-85.794595h-240.778379v-35.978378h238.010811l2.767568 35.978378z" fill="#FAC15C" p-id="3396"></path></svg>
                                <svg v-if="rate.invoice === 2" t="1777268148730" class="icon" viewBox="0 0 1300 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3540" width="16" height="16"><path d="M1214.73563 0H60.875134C24.903464 0 0 27.670515 0 58.108083V359.716701c0 22.136412 16.602309 33.204619 30.437567 35.971671 58.108083 13.835258 94.079753 66.409237 94.079753 130.051422 0 58.108083-44.272825 116.216165-99.613856 132.818475-13.835258 2.767052-24.903464 16.602309-24.903464 33.204618v271.171052C0 996.138558 24.903464 1023.809073 60.875134 1023.809073h1153.860496c35.97167 2.767052 60.875134-24.903464 60.875134-60.875134v-276.705155c0-19.369361-11.068206-33.204619-24.903463-33.204618-58.108083-13.835258-110.682062-69.176289-110.682062-127.284372 0-60.875134 44.272825-118.983217 107.91501-130.051422 16.602309-2.767052 27.670515-13.835258 27.670515-35.971671V58.108083C1275.610764 27.670515 1245.173197 0 1214.73563 0z" fill="#1FA261" p-id="3541"></path><path d="M1148.326393 293.307464V168.790145c0-22.136412-19.369361-47.039876-44.272825-47.039877H157.721938c-22.136412 0-41.505773 19.369361-41.505773 44.272825v127.284371C188.159505 337.580289 240.733485 415.057732 240.733485 525.739794c0 88.54565-55.341031 168.790145-124.51732 221.364124v116.216166c0 24.903464 19.369361 38.738722 35.97167 38.738721h951.865733c22.136412 0 44.272825-19.369361 44.272825-41.505773V747.103918c-69.176289-44.272825-141.119629-121.750268-141.119629-221.364124 0-99.613856 58.108083-182.625402 141.119629-232.43233z" fill="#FDFEFF" p-id="3542"></path><path d="M835.649568 434.427093H581.080825l16.60231-63.642185h201.994763c16.602309 0 27.670515-11.068206 27.670515-24.903464 0-11.068206-11.068206-24.903464-24.903464-24.903464h-188.159505l5.534103-24.903464c5.534103-13.835258-5.534103-38.738722-27.670515-38.738722-8.301155 0-19.369361 8.301155-22.136413 19.369361l-11.068206 38.738722h-121.750268c-13.835258 0-24.903464 8.301155-24.903464 22.136412s11.068206 24.903464 24.903464 24.903464h107.91501l-19.369361 71.94334h-130.051422c-13.835258 0-24.903464 11.068206-24.903464 24.903464s8.301155 22.136412 22.136412 22.136413h118.983217l-22.136413 69.176288c-8.301155 24.903464 13.835258 33.204619 24.903464 33.204619l201.994763-2.767052-85.778598 83.011547c-35.97167-11.068206-74.710392-22.136412-116.216165-30.437567-30.437567-8.301155-47.039876 47.039876-13.835257 49.806928 71.94334 13.835258 152.187835 44.272825 207.528866 77.477443 33.204619 22.136412 69.176289-30.437567 24.903464-49.806928-16.602309-8.301155-33.204619-16.602309-55.341031-24.903464l116.216165-107.91501c22.136412-24.903464 11.068206-47.039876-22.136413-47.039876l-224.131175 2.767051 16.602309-55.341031h271.171052c13.835258 0 24.903464-8.301155 24.903464-24.903464 0-8.301155-11.068206-19.369361-24.903464-19.369361z" fill="#1FA261" p-id="3543"></path></svg>
                                <span :style="{color: rate.invoice === 1 ? '#fac15c' : '#1fa261'}">{{invoiceTypMap[rate.invoice] }}</span>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <div style="display: flex;align-items: center;margin-bottom: 5px;color: #2947ec;column-gap: 5px"
                                 v-if="rate.instantConfirm === 1">
                              <i class="iconfont icon-lijiqueren" style="font-size: 14px"/>
                              <span style="font-size: 14px;">立即确认</span>
                            </div>
                            <div style="display: flex;align-items: center;column-gap: 3px;">
                              <div style="font-size: 14px;display: flex;align-items: center;column-gap: 5px">
                                <svg v-if="rate.invoice === 1" t="1777268089850" class="icon" viewBox="0 0 1300 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3393" width="16" height="16"><path d="M1250.940541 392.994595c13.837838-2.767568 27.675676-11.07027 27.675675-33.210811V55.351351c-2.767568-27.675676-27.675676-55.351351-55.351351-55.351351H63.654054C35.978378 0 0 24.908108 0 58.118919v298.897297c0 19.372973 13.837838 35.978378 27.675676 35.978379 58.118919 13.837838 110.702703 60.886486 110.702702 135.61081 0 55.351351-44.281081 116.237838-110.702702 130.075676-13.837838 2.767568-27.675676 16.605405-27.675676 30.443243v273.98919C0 996.324324 24.908108 1024 60.886486 1024h1159.610811c30.443243 0 60.886486-24.908108 60.886487-60.886486v-276.756757c0-19.372973-11.07027-33.210811-30.443243-35.978379-55.351351-13.837838-99.632432-69.189189-99.632433-124.54054 0-60.886486 44.281081-121.772973 99.632433-132.843243z" fill="#FAC15C" p-id="3394"></path><path d="M1156.843243 293.362162V166.054054c-2.767568-22.140541-19.372973-44.281081-41.513513-44.281081h-940.972973c-22.140541 0-44.281081 19.372973-44.281081 41.513513v130.075676C199.264865 334.875676 265.686486 415.135135 265.686486 525.837838c0 94.097297-52.583784 168.821622-132.843243 224.172973v110.702703c0 24.908108 24.908108 41.513514 38.745946 41.513513h949.275676c22.140541 0 38.745946-19.372973 38.745946-44.281081v-107.935135c-69.189189-47.048649-127.308108-124.540541-127.308108-224.172973 0-83.027027 49.816216-182.659459 124.54054-232.475676z" fill="#FDFEFF" p-id="3395"></path><path d="M877.318919 481.556757c0-11.07027-8.302703-16.605405-19.372973-16.605406h-132.843243v-110.702702h116.237838c11.07027 0 24.908108-8.302703 24.908108-22.140541 0-11.07027-8.302703-24.908108-19.372973-24.908108h-96.864865l19.372973-38.745946c0-22.140541-35.978378-38.745946-49.816216-13.837838l-19.372973 52.583784h-110.702703l-19.372973-52.583784c-11.07027-30.443243-60.886486-16.605405-38.745946 16.605406l11.07027 33.21081h-85.794594c-13.837838 0-22.140541 8.302703-22.140541 24.908109 0 11.07027 8.302703 24.908108 19.372973 24.908108h113.47027v110.702702h-141.145946c-11.07027 0-22.140541 8.302703-22.14054 22.140541 0 11.07027 8.302703 22.140541 19.372973 22.14054h453.881081c8.302703 0 22.140541-11.07027 19.372973-27.675675h-19.372973z m-204.8-16.605406h-58.118919v-107.935135h58.118919v107.935135z m-132.843243-13.837837c11.07027-8.302703 2.767568-24.908108 0-33.210811l-19.372973-38.745946c-13.837838-19.372973-52.583784-8.302703-41.513514 13.837838L498.162162 442.810811c8.302703 16.605405 27.675676 13.837838 41.513514 8.302703z m251.848648-8.302703l33.210811-52.583784c5.535135-22.140541-27.675676-35.978378-41.513513-19.372973l-27.675676 55.351351c-5.535135 22.140541 27.675676 38.745946 35.978378 16.605406z m0 96.864865H506.464865c-13.837838 0-27.675676 11.07027-27.675676 24.908108V747.243243c0 24.908108 49.816216 38.745946 52.583784 0h238.010811c0 30.443243 52.583784 44.281081 52.583784 0v-182.659459c0-11.07027-11.07027-27.675676-30.443244-24.908108z m-22.14054 160.518919h-240.778379v-47.048649h240.778379v47.048649z m0-85.794595h-240.778379v-35.978378h238.010811l2.767568 35.978378z" fill="#FAC15C" p-id="3396"></path></svg>
                                <svg v-if="rate.invoice === 2" t="1777268148730" class="icon" viewBox="0 0 1300 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3540" width="16" height="16"><path d="M1214.73563 0H60.875134C24.903464 0 0 27.670515 0 58.108083V359.716701c0 22.136412 16.602309 33.204619 30.437567 35.971671 58.108083 13.835258 94.079753 66.409237 94.079753 130.051422 0 58.108083-44.272825 116.216165-99.613856 132.818475-13.835258 2.767052-24.903464 16.602309-24.903464 33.204618v271.171052C0 996.138558 24.903464 1023.809073 60.875134 1023.809073h1153.860496c35.97167 2.767052 60.875134-24.903464 60.875134-60.875134v-276.705155c0-19.369361-11.068206-33.204619-24.903463-33.204618-58.108083-13.835258-110.682062-69.176289-110.682062-127.284372 0-60.875134 44.272825-118.983217 107.91501-130.051422 16.602309-2.767052 27.670515-13.835258 27.670515-35.971671V58.108083C1275.610764 27.670515 1245.173197 0 1214.73563 0z" fill="#1FA261" p-id="3541"></path><path d="M1148.326393 293.307464V168.790145c0-22.136412-19.369361-47.039876-44.272825-47.039877H157.721938c-22.136412 0-41.505773 19.369361-41.505773 44.272825v127.284371C188.159505 337.580289 240.733485 415.057732 240.733485 525.739794c0 88.54565-55.341031 168.790145-124.51732 221.364124v116.216166c0 24.903464 19.369361 38.738722 35.97167 38.738721h951.865733c22.136412 0 44.272825-19.369361 44.272825-41.505773V747.103918c-69.176289-44.272825-141.119629-121.750268-141.119629-221.364124 0-99.613856 58.108083-182.625402 141.119629-232.43233z" fill="#FDFEFF" p-id="3542"></path><path d="M835.649568 434.427093H581.080825l16.60231-63.642185h201.994763c16.602309 0 27.670515-11.068206 27.670515-24.903464 0-11.068206-11.068206-24.903464-24.903464-24.903464h-188.159505l5.534103-24.903464c5.534103-13.835258-5.534103-38.738722-27.670515-38.738722-8.301155 0-19.369361 8.301155-22.136413 19.369361l-11.068206 38.738722h-121.750268c-13.835258 0-24.903464 8.301155-24.903464 22.136412s11.068206 24.903464 24.903464 24.903464h107.91501l-19.369361 71.94334h-130.051422c-13.835258 0-24.903464 11.068206-24.903464 24.903464s8.301155 22.136412 22.136412 22.136413h118.983217l-22.136413 69.176288c-8.301155 24.903464 13.835258 33.204619 24.903464 33.204619l201.994763-2.767052-85.778598 83.011547c-35.97167-11.068206-74.710392-22.136412-116.216165-30.437567-30.437567-8.301155-47.039876 47.039876-13.835257 49.806928 71.94334 13.835258 152.187835 44.272825 207.528866 77.477443 33.204619 22.136412 69.176289-30.437567 24.903464-49.806928-16.602309-8.301155-33.204619-16.602309-55.341031-24.903464l116.216165-107.91501c22.136412-24.903464 11.068206-47.039876-22.136413-47.039876l-224.131175 2.767051 16.602309-55.341031h271.171052c13.835258 0 24.903464-8.301155 24.903464-24.903464 0-8.301155-11.068206-19.369361-24.903464-19.369361z" fill="#1FA261" p-id="3543"></path></svg>
                                <span :style="{color: rate.invoice === 1 ? '#fac15c' : '#1fa261'}">{{invoiceTypMap[rate.invoice] }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div v-if="item.roomId === -1" style="margin-bottom: 8px">
                            {{ rate.bedInfo }}
                          </div>
                          <div>
                          <span v-if="rate.mealCount == 0"
                                style="font-size: 14px;color: #5b626d">
                            {{ $t('hotel_detail.Breakfast_not_included') }}
                          </span>
                            <span v-else style="font-size: 14px;color: #5b626d">
                            {{ rate.mealCount }}
                            {{ $t('hotel_detail.breakfast_count') }}
                          </span>
                          </div>
                        </div>
                        <div>
                          <div v-if="rate.cancel == 'yes'" style="color: #00b63d;">
                            <div class="cancel_policy">
                              <i class="el-icon-success"/>
                              <span>限时取消</span>
                            </div>
                            <div style="color: #5d6672;font-size: 12px">{{
                                rate.b2bCancel
                              }}{{ $t('hotel_detail.Free_cancellation_before') }}
                            </div>
                          </div>
                          <div v-else style="color: #ff5256">
                            <div class="no_cancel_policy">
                              <i class="el-icon-error"/>
                              <span>不可取消</span>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div v-if="rate.ratePerson > 0 && rate.ratePerson <= 3">
                            <i class="iconfont icon-rentou" style="margin-right: 3px;color: #4b5563"
                               v-for="i in rate.ratePerson"
                               :key="i"/>
                          </div>
                          <div v-else>
                            <i class="iconfont icon-rentou" style="color: #4b5563"/> x {{ rate.ratePerson }}
                          </div>
                        </div>
                        <div>
                          <el-popover placement="bottom" width="300" trigger="hover">
                            <span slot="reference" class="oneday-price">
                              ￥{{ Math.ceil(rate.price / rate.dailyRates.length / bookingInfo.room) }}
                            </span>
                            <div>
                              <div>客房每日价格：</div>
                              <table class="price-tab">
                                <tr>
                                  <th>日期</th>
                                  <th>房价/间/晚</th>
                                </tr>
                                <tr v-for="(item, i) in rate.dailyRates" :key="i">
                                  <td>
                                    {{ item.date }}
                                  </td>
                                  <td style="color: #ff5256">￥{{ item.value }}</td>
                                </tr>
                                <tr>
                                  <th colspan="2">
                                    总价：<span style="color: #ff5256">
                                      ￥{{ rate.price }}
                                    </span>
                                    ({{
                                      rate.dailyRates ? rate.dailyRates.length : 0
                                    }}晚，{{ bookingInfo.room }}间)
                                  </th>
                                </tr>
                              </table>
                            </div>
                          </el-popover>
                          <div style="font-size: 12px; color: #999999">
                            {{ $t('hotel_detail.total') }} ￥{{ rate.price }}
                          </div>
                        </div>
                        <div>
                          <el-button style="color: #ffffff;" class="bookingBtn"
                                     @click="toBookingDetail(rate,item.roomId,item.nameCn,item.nameEn,item.bedInfo, item)">
                            {{ $t('hotel_detail.Book_Now') }}
                          </el-button>
                        </div>
                      </div>
                    </div>
                    <div class="more_btn" @click="expandItem(item)"
                         v-if="item.rates && item.rates.length > 2">
                      {{ expandMap[item.roomId] ? '收起' : '展开更多' }}
                      <i :class="expandMap[item.roomId] ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"/>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="isLogin && (!roomInfos || roomInfos.length == 0)">
                <div
                  style="text-align: center; font-size: 20px;height: 400px; background-color: #ffffff;display: flex;align-items: center;justify-content: center;width: 1180px;margin: auto;">
                  <span v-if="dataLoading">&nbsp;</span>
                  <span v-else-if="
                  !hotelInfo.roomInfos || hotelInfo.roomInfos.length == 0
                ">暂无可售房型</span>
                  <span v-else>暂无符合条件房型</span>
                </div>
              </template>
              <template v-else-if="!isLogin">
                <div style="text-align: center; background-color: #ffffff; height: 400px;width: 1180px;margin: auto;">
                  <div style="height: 150px"></div>
                  <div style="color: #000; font-size: 16px;font-family: '微软雅黑';">
                    马上登录，查看最新报价
                  </div>
                  <div style="height: 30px"></div>
                  <el-button type="primary" style="width: 135px;font-family: '微软雅黑';" @click="toLogin">
                    登录
                  </el-button>
                </div>
              </template>
            </el-row>
            <div style="font-size: 14px;width: 1180px;margin: auto;background-color: #FFFFFF;margin-top: 20px;border-radius: 8px"
                 class="menu-item-row">
              <div class="hotel_desc_poriner" ref="hotel_desc_poriner"></div>
              <div style="border-bottom: 1px solid #f2f2f2;margin-bottom: 15px">
                <div>
                <span style="font-size: 18px; margin-left: 20px; font-weight: 600;color: #1e50f0">
                {{ $t('hotel_detail.Hotel_introduction') }}
                </span>
                  <span style="color: #aaaaaa; margin-left: 5px;font-size: 12px">
                  {{ $t('hotel_detail.follow_info') }}
                </span>
                </div>
                <div style="margin: 20px; line-height: 30px; font-weight: 500;font-size: 13px;color: #374151">
                  <div>
                  <span class="desc_title"
                        v-if="hotelInfo.reDate && hotelInfo.reDate.split('-')[0] !== '1900'">装修时间：</span>
                    <span v-if="hotelInfo.reDate && hotelInfo.reDate.split('-')[0] !== '1900'" style="margin-right: 10px;">
                      {{ hotelInfo.reDate ? hotelInfo.reDate : '' }}
                    </span>
                    <span class="desc_title"
                          v-if="hotelInfo.esDate">开业时间：</span>{{ hotelInfo.esDate ? hotelInfo.esDate : '' }}
                  </div>
                  <div v-if="hotelInfo.hotelPhone">
                    <span class="desc_title">{{ $t('hotel_detail.Hotel_telephone') }}：</span>{{ hotelInfo.hotelPhone }}
                  </div>
                  <div v-if="hotelInfo.addressCn">
                    <span class="desc_title">{{ $t('hotel_detail.Chinese_address') }}：</span>{{ hotelInfo.addressCn }}
                  </div>
                  <div v-if="hotelInfo.addressEn">
                    <span class="desc_title">{{ $t('hotel_detail.English_address') }}：</span>{{ hotelInfo.addressEn }}
                  </div>
                  <div v-if="hotelInfo.descArr && hotelInfo.descArr.length">
                    <span class="desc_title">{{ $t('hotel_detail.Hotel_Profile') }}：</span>
                    <span v-for="(item, index) in hotelInfo.descArr" :key="index">{{ item }}</span>
                  </div>
                </div>
              </div>

              <div class="policy_point" ref="policy_point"></div>
              <div style="border-bottom: 1px solid #f2f2f2;margin-bottom: 15px">
                <div>
                  <span style="font-size: 15px;margin-left: 20px; font-weight: 600;color: #000000">酒店政策</span>
                </div>
                <div style="margin: 20px; line-height: 30px; font-weight: 500;font-size: 13px;color: #374151">
                  <div v-if="$commonUtil.getCnStr(hotelInfo.arrivalCn, hotelInfo.arrival)">
                    <span class="desc_title">入住时间：</span>{{
                      $commonUtil.getCnStr(hotelInfo.arrivalCn, hotelInfo.arrival)
                    }}
                  </div>
                  <div v-if="$commonUtil.getCnStr(hotelInfo.departCn, hotelInfo.depart)">
                    <span class="desc_title">离店时间：</span>{{
                      $commonUtil.getCnStr(hotelInfo.departCn, hotelInfo.depart)
                    }}
                  </div>
                  <div v-if="hotelInfo.customerType"><span class="desc_title">宾客类型：</span>{{ getCustomerType() }}
                  </div>
                  <div v-if="hotelInfo.petPolicyCn"><span class="desc_title">宠物政策：</span>{{ hotelInfo.petPolicyCn }}
                  </div>
                  <div v-if="Object.keys(hotelPolicy)">
                    <div v-if="hotelPolicy.Notices">
                      <span class="desc_title">重要提示：</span>
                      <span v-for="(item, index) in hotelPolicy.Notices" :key="index">{{ item }}</span>
                    </div>
                    <div v-if="hotelPolicy.CheckinPolicy">
                      <span class="desc_title">入住政策：</span>
                      <span v-for="(item, index) in hotelPolicy.CheckinPolicy" :key="index">{{ item }}</span>
                    </div>
                    <div v-if="hotelPolicy.DepositPolicy">
                      <span class="desc_title">押金政策：</span>
                      <span v-for="(item, index) in hotelPolicy.DepositPolicy" :key="index">{{ item }}</span>
                    </div>
                    <div v-if="hotelPolicy.NoShowPolicy">
                      <span class="desc_title">NoShow政策：</span>
                      <span v-for="(item, index) in hotelPolicy.NoShowPolicy" :key="index">{{ item }}</span>
                    </div>
                    <div v-if="hotelPolicy.ChildPolicy">
                      <span class="desc_title">儿童政策：</span>
                      <span v-for="(item, index) in hotelPolicy.ChildPolicy" :key="index">{{ item }}</span>
                    </div>
                    <div v-if="hotelPolicy.PetPolicy">
                      <span class="desc_title">宠物政策：</span>
                      <span v-for="(item, index) in hotelPolicy.PetPolicy" :key="index">{{ item }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="facility_point" ref="facility_point"></div>
              <div v-if="hotelInfo.hotelFacilities && hotelInfo.hotelFacilities.length"
                   style="padding-bottom: 1px" >
                <div>
                  <span style="font-size: 15px;margin-left: 20px; font-weight: 600;color: #000000">酒店设施</span>
                </div>
                <div style="margin: 20px; line-height: 30px; font-weight: 500;font-size: 13px;color: #374151">
                  <div>
                    <p v-for="(item, index) in hotelInfo.hotelFacilities" :key="index">
                    <span class="desc_title">
                      <i class="el-icon-check" style="color: #09b455;margin-right: 5px;font-weight: 600"/>
                      {{item.cn }}:
                    </span>
                      <span v-for="(items, i) in item.facilities" :key="i" class="hotel_facilities">
                        {{ items }}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style="font-size: 14px;width: 1180px;margin: auto;background-color: #FFFFFF;margin-top: 20px;border-radius: 8px"
          class="menu-item-row">
          <div style="font-size: 18px; margin-left: 20px; font-weight: 600;color: #1e50f0">
            相关酒店推荐
          </div>
          <div class="recommend_hotel_box">
            <div class="item" v-for="(item, index) in recommendHotels" :key="index" @click="toHotelDetail(item)">
              <div class="hotel_img">
                <img :src="item.hotelImages" v-if="item.hotelImages">
                <div class="no_img" v-else>
                  <img src="../../../assets/newImage/noSwiperImg1.png">
                </div>
              </div>
              <div class="hotel_name">
                {{ item.nameCn }}
              </div>
              <div style="display: flex;align-items: center;margin-bottom: 15px;column-gap: 15px">
                <div class="hotel_star" v-if="item.star">
                  <el-rate v-model="item.star" disabled></el-rate>
                  <span>{{ item.starText }}</span>
                </div>
                <div class="hotel_star" v-if="!item.star && item.category">
                  <el-rate v-model="item.category" disabled disabled-void-icon-class="iconfont icon-zuanshi"
                           :icon-classes="['iconfont icon-zuanshi', 'iconfont icon-zuanshi', 'iconfont icon-zuanshi', 'iconfont icon-zuanshi', 'iconfont icon-zuanshi']"></el-rate>
                  <span>{{ $commonUtil.getCategoryDesc(item.category) }}</span>
                </div>
                <div class="hotel_star" v-if="!item.star && !item.category">
                  <el-rate :value="2" disabled></el-rate>
                  <span>{{ item.starText }}</span>
                </div>
              </div>
              <div style="color: #6B7280;font-size: 13px;display: flex;justify-content: space-between">
                <span>距离{{ item.distance }}公里</span>
                <span style="color: #1e50f0;font-weight: 600" v-if="item.price">
                    <span style="margin-right: 5px">CNY</span>{{ item.price }}<span
                  style="margin-left: 5px;font-size: 15px">起</span>
                  </span>
              </div>
            </div>
          </div>
        </div>
        <el-dialog :visible.sync="isShowReturn" :show-close="false" :center="true" :close-on-click-modal="false"
                   :close-on-press-escape="false" width="500px">
          <div style="text-align: center; font-size: 18px">
            <div>手慢了，请返回重新选择购买！</div>
            <div class="btn-normal">
              <el-button type="primary" @click="toHotelList" style="margin-top: 30px; width: 100%">
                确定
              </el-button>
            </div>
          </div>
        </el-dialog>
        <el-dialog :visible.sync="isShowContinue" :show-close="false" :center="true" :close-on-click-modal="false"
                   :close-on-press-escape="false" width="500px">
          <div style="font-size: 18px; line-height: 25px">
            <div>酒店价格发生变化，每日均价升高{{ upPrice }}，是否继续预订？</div>
            <div style="text-align: center; margin-top: 30px">
              <el-button @click="toHotelList" style="width: 200px">
                返回
              </el-button>
              <el-button type="warning" @click="toDetail" style="width: 200px">
                继续预订
              </el-button>
            </div>
          </div>
        </el-dialog>
        <div style="margin-bottom: 90px"></div>
      </div>

      <!--   底部   -->
      <div style="width: 100%;  background-color:#fff;">
        <ContantUs></ContantUs>
        <footerInfo/>
      </div>

    </div>
    <HotelImg ref="hotelImgRef"/>
    <ProductDialog ref="productDialogRef" />
  </div>
</template>

<script>
import {BaiduMap} from 'vue-baidu-map'
import RadioSpan from './components/RadioSpan.vue'
import HomeHeader from './components/HomeHeader.vue'
import ContantUs from './components/ContantUs.vue'
import footerInfo from '../frame/footerInfo.vue'
import HotelImg from './components/HotelImg.vue'
import htmlToPdf from '../../../utils/htmlToPdf'
import ProductDialog from './components/productDialog.vue'

export default {
  data () {
    return {
      searchForm: {},
      hotelInfo: {},
      hotelInfoBriefly: {},
      selectIndex: '1',
      isLogin: this.$commonUtil.isLogin(),
      roomInfoActiveNames: [],
      bookingInfo: {},
      checkRateInfo: {},
      checkRateReq: {},
      isShowReturn: false,
      isShowContinue: false,
      upPrice: 0,
      mapCenter: {
        lng: 0,
        lat: 0
      },
      mapZoom: 16,
      dataLoading: true,
      pickerOptions: {
        disabledDate (v) {
          return v.getTime() < new Date().getTime() - 86400000
        }
      },
      isSuckTop: false,
      radioForm: {
        bedType: null,
        breakfastType: null
      },
      bedTypeList: [
        {name: this.$t('hotel_detail.king_bed'), value: [2]},
        {name: this.$t('hotel_detail.Double_bed'), value: [3]},
        {name: this.$t('hotel_detail.Single_bed'), value: [1]},
        {name: this.$t('hotel_detail.Large_double_bed'), value: [9]}
      ],
      breakfastList: [
        {name: this.$t('hotel_detail.has_breakfast'), value: 1},
        {name: this.$t('hotel_detail.Single_breakfast'), value: 2},
        {name: this.$t('hotel_detail.Double_breakfast'), value: 3}
      ],
      invoiceList: [
        {name: '专票', value: 2},
        {name: '普票', value: 1}
      ],
      isCancel: false,
      roomNames: [],
      selectBedType: null,
      selectBreakfastType: null,
      selectInvoiceType: null,
      selectRoomId: null,
      scoreTextMap: {
        '5.0': '超级棒',
        '5': '超级棒',
        '4.9': '非常棒',
        '4.8': '棒',
        '4.7': '很好',
        '4.6': '好',
        '4.5': '不错'
      },
      customerTypes: {
        0: '不限',
        1: '内宾',
        2: '外宾',
        3: '港澳台'
      },
      windowTypeMap: {
        0: '无窗',
        1: '有窗',
        2: '部分有窗',
        3: '暗窗',
        5: '封闭窗',
        4: '窗型未知'
      },
      invoiceTypMap: {
        1: '普票',
        2: '专票'
      },
      expandMap: {},
      currentRoom: {},
      showIconFacilities: ['停车场', 'wifi', '会议厅', '代客泊车'],
      showIconMap: {
        '停车场': 'icon-tingchechang',
        'wifi': 'icon-WiFi',
        '会议厅': 'icon-a-qietu163',
        '代客泊车': 'icon-jiesongfuwu'
      },
      recommendHotels: [],
      hotelPolicy: {}
    }
  },
  components: {
    ProductDialog,
    BaiduMap,
    RadioSpan,
    HomeHeader,
    ContantUs,
    footerInfo,
    HotelImg
  },
  created () {
    document.addEventListener('scroll', this.handleScroll)
    document.addEventListener('click', this.handleClick)
    this.init()
  },
  mounted () {
    document.addEventListener('scroll', this.handleScroll)
    document.addEventListener('click', this.handleClick)
    this.$commonUtil.modfiyicon()
  },
  destroyed () {
    document.removeEventListener('scroll', this.handleScroll)
    document.removeEventListener('click', this.handleClick)
  },
  computed: {
    roomInfos () {
      if (this.hotelInfo.roomInfos) {
        let result = []
        for (let i = 0; i < this.hotelInfo.roomInfos.length; i++) {
          let item = this.hotelInfo.roomInfos[i]
          if (this.selectBedType || this.selectBreakfastType || this.selectRoomId || this.isCancel || this.selectInvoiceType) {
            if (this.selectRoomId && item.roomId !== this.selectRoomId) continue
            if ((this.isContainBedType(item.bedInfo) || item.roomId === -1) && this.isContainBreakfastType(item.rates)
              && this.isContainCancelType(item.rates) && this.isContainInvoiceType(item.rates)) {
              let newRates = this.getFilterRates(item.rates, item)
              let newItem = this.$commonUtil.deepCopy(item)
              newItem.rates = newRates
              if (newItem.rates.length) {
                result.push(newItem)
              }
            }
          } else {
            result.push(item)
          }
        }
        return result
      }
      return []
    },
    isLang () {
      return localStorage.getItem('lang') == 'en'
    }
  },
  methods: {
    init () {
      this.searchForm = this.$commonUtil.localStorageGetItem('hotelDetailSearchForm')
      if (this.searchForm == null) {
        this.$router.push('/NewHome')
        return
      }
      this.searchForm['room'] = parseInt(this.searchForm.room) ? parseInt(this.searchForm.room) : 1
      this.searchForm['adult'] = parseInt(this.searchForm.adult) ? parseInt(this.searchForm.adult) : 2
      this.searchForm['taxFeeAsCost'] = 1
      this.searchForm['showPackagePrice'] = true
      this.onSearch(true)
    },
    getUUID () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    onSearch (search) {
      this.$commonUtil.localStorageSetItem('hotelDetailSearchForm', this.searchForm)
      let reqHeader
      if (!this.isLogin) {
        this.searchForm['defaultUser'] = true
      } else {
        reqHeader = {
          accessToken: JSON.parse(localStorage.getItem('partnerInfo')).token
        }
      }
      this.isCancel = false
      this.searchForm['website'] = true
      this.roomNames = []
      let vm = this
      vm.dataLoading = true
      vm.hotelInfo = {}
      vm.hotelPolicy = {}
      vm.$http.post('/mini/hotelDetail', vm.searchForm, {headers: reqHeader}).then(resp => {
        let result = resp.data.data
        if (!result) {
          vm.$message.warning('该酒店暂无可售房型，请重新选择。')
          vm.$router.push('/NewHome')
          return
        }
        vm.hotelInfo = result
        if (vm.hotelInfo.allImages) {
          vm.hotelInfo.allImages.forEach(item => {
            vm.$set(item, 'key', vm.getUUID())
          })
        }
        // 房型图片处理
        vm.hotelInfo.roomInfos.forEach(item => {
          if (!vm.roomNames.some(i => i.value === item.roomId)) {
            vm.roomNames.push({
              name: item.nameCn,
              value: item.roomId
            })
          }
          vm.$set(vm.expandMap, item.roomId, false)
        })
        // vm.getRoomInfoActiveNames()
        vm.bookingInfo = vm.$commonUtil.deepCopy(vm.searchForm)
        // vm.hotelInfo.descCn = vm.hotelInfo.descCn ? vm.hotelInfo.descCn.split('<br>') : ''
        let desc = vm.$commonUtil.getCnStr(vm.hotelInfo.descCn, vm.hotelInfo.desc)
        vm.hotelInfo.descArr = desc ? desc.split('<br>') : ''
        if (vm.hotelInfo.dLong && vm.hotelInfo.dLati) {
          vm.mapCenter = {
            lng: vm.hotelInfo.dLong,
            lat: vm.hotelInfo.dLati
          }
        }
        if (vm.hotelInfo.roomInfos) {
          let roomBeds = vm.hotelInfo.roomInfos.reduce((acc, room) => {
            const bedInfo = room.bedInfo
            if (room.bedInfo && !acc.some(item => item.value === bedInfo)) {
              acc.push({name: bedInfo, value: bedInfo})
            }
            return acc
          }, [])
          let otherRoom = vm.hotelInfo.roomInfos.find(r => r.roomId === -1)
          let otherBeds = []
          if (otherRoom && otherRoom.rates) {
            otherBeds = otherRoom.rates.reduce((acc, room) => {
              const bedInfo = room.bedInfo
              if (room.bedInfo && !acc.some(item => item.value === bedInfo)) {
                acc.push({name: bedInfo, value: bedInfo})
              }
              return acc
            }, [])
          }
          vm.bedTypeList = vm.uniqueArray([...roomBeds, ...otherBeds])
        }
        let policy =  vm.$commonUtil.getCnStr(vm.hotelInfo.otherPolicyCn, vm.hotelInfo.otherPolicy)
        try {
          if (policy) {
            vm.hotelPolicy = JSON.parse(policy)
            console.log(vm.hotelPolicy)
          }
        } catch (e) {
          console.log(e)
        }
      }).catch(resp => {
        // vm.$router.push('/NewHome')
        console.log(resp)
      }).finally(() => {
        vm.dataLoading = false
        if (search) {
          vm.searchRecommendHotels()
        }
      })
    },
    async searchRecommendHotels () {
      if (!this.hotelInfo.dLong && !this.hotelInfo.dLati) return
      let reqHeader = {
        accessToken: this.$common.isLogin() ? JSON.parse(this.$common.isLogin()).token : ''
      }
      let reqData = {
        checkIn: this.$common.formatterDate(new Date()),
        pageInx: 1,
        pageSize: 4,
        sortBy: 5,
        poiType: true,
        regionId: this.$commonUtil.getRegionBySHotelId(this.hotelInfo.hotelId),
        userLongitude: this.hotelInfo.dLong,
        userLatitude: this.hotelInfo.dLati
      }
      const {data: result} = await this.$http.post('/mini/searchCityHotels', reqData, {headers: reqHeader})
      if (result.code !== 200) return
      this.recommendHotels = result.data.hotels ? result.data.hotels.filter(i => i.hotelId !== this.hotelInfo.hotelId).slice(0, 3) : []
      if (this.recommendHotels.length > 0) {
        this.recommendHotels.forEach(item => {
          item.distance = this.distanceLgorthm(item.longitude, item.latitude, this.hotelInfo.dLong, this.hotelInfo.dLati)
        })
      }
    },
    distanceLgorthm (longitude, latitude, userLongitude, userLatitude) {
      const EARTH_RADIUS = 6378137
      let degree_lat1 = (userLatitude * Math.PI) / 180.0
      let degree_lat2 = (latitude * Math.PI) / 180.0
      let a = degree_lat1 - degree_lat2
      let degree_lng1 = (userLongitude * Math.PI) / 180.0
      let degree_lng2 = (longitude * Math.PI) / 180.0
      let b = degree_lng1 - degree_lng2
      // 距离 （单位：米）
      let s = 2 * Math.asin(
        Math.sqrt(
          Math.pow(Math.sin(a / 2), 2) +
          Math.cos(degree_lat1) *
          Math.cos(degree_lat2) *
          Math.pow(Math.sin(b / 2), 2)
        )
      )
      s = s * EARTH_RADIUS
      s = Math.round(s * 10000) / 10000
      return (s / 1000).toFixed(1)
    },
    uniqueArray (arr) {
      const seen = new Set()
      return arr.filter(item => {
        const key = `${item.name}${String.fromCharCode(0)}${item.value}`
        return seen.has(key) ? false : seen.add(key)
      })
    },
    infoSelect (key) {
      this.selectIndex = key
    },
    getRoomInfoActiveNames () {
      let arr = []
      if (this.roomInfos) {
        for (let i = 0; this.roomInfos.length; i++) {
          if (i == 4) {
            break
          }
          arr.push(i)
        }
      }
      this.roomInfoActiveNames = arr
    },
    toBookingDetail (row, roomId, roomNameCn, roomNameEn, bedInfo, room) {
      if (!this.isLogin) {
        this.$message.warning('请求错误，请登录')
        this.$router.push('/login')
        return
      }
      // 验价
      let loading = this.$loading({
        // lock: true,
        text: '努力加载中，请稍后.....',
        spinner: 'el-icon-loading',
        background: this.$finalData.LoadingBgColorAll
      })
      this.checkRateReq = {
        hotelId: this.bookingInfo.hotelId,
        roomId: roomId,
        rateId: row.rateId,
        checkIn: this.bookingInfo.checkIn,
        checkOut: this.bookingInfo.checkOut,
        currency: this.$finalData.CNYCurrency,
        adults: row.ratePerson,
        rooms: this.bookingInfo.room,
        totalNet: row.price + '',
        channelId: this.searchForm.channelId,
        rateCode: row.rateCode,
        ratePlanCode: row.ratePlanCode,
        supplierId: row.supplierId,
        showPackagePrice: row.rateCode == 'P' ? true : false,
        taxFeeAsCost: 1,
        rateKey: row.rateKey,
        pkgProductId: row.pkgProductInfo ? row.pkgProductInfo.pkgProductId : null,
        showPkgProductInfo: row.pkgProductInfo
      }
      let checkRateHeader = {
        // partnerCode: this.$commonUtil.getPartnerInfo().partnerCode + '',
        accessToken: JSON.parse(localStorage.getItem('partnerInfo')).token
      }
      this.currentRoom = room
      let vm = this
      vm.$http.post('/mini/checkRate', vm.checkRateReq, {headers: checkRateHeader}).then(resp => {
        let result = resp.data.data
        if (!result) {
          return this.$message.warning(resp.body.message)
        }
        if (!result.net) {
          vm.isShowReturn = true
          return
        } else {
          vm.checkRateInfo = result
          vm.hotelInfoBriefly = {
            nameCn: vm.hotelInfo.nameCn,
            nameEn: vm.hotelInfo.nameEn,
            star: vm.hotelInfo.star,
            addressCn: vm.hotelInfo.addressCn,
            addressEn: vm.hotelInfo.addressEn,
            hotelImages: vm.hotelInfo.images,
            score: vm.hotelInfo.score,
            category: vm.hotelInfo.category,
            district: vm.hotelInfo.district,
            bedInfo: row.bedInfo ? row.bedInfo : bedInfo,
            roomNameCn: row.nameCn ? row.nameCn : roomNameCn,
            roomNameEn: row.nameEn ? row.nameEn : roomNameEn,
            mealCount: row.mealCount
          }
          vm.upPrice = result.net - row.price
          if (vm.upPrice > 0) {
            vm.isShowContinue = true
          } else {
            vm.upPrice = 0
            vm.toDetail()
          }
        }
      }).catch(resp => {
        vm.$message.error('Error：' + resp.status + ' - ' + resp.statusText)
      }).finally(() => {
        loading.close()
      })
    },
    toDetail () {
      let req = {
        rateInfo: this.checkRateInfo,
        checkRateReq: this.checkRateReq,
        hotelInfo: this.hotelInfoBriefly,
        searchForm: this.bookingInfo,
        room: this.currentRoom
      }
      this.$router.push({
        name: 'bookingDetail',
        path: '/bookingDetail',
        params: req
      })
    },
    toHotelList () {
      this.$commonUtil.localStorageSetItem('bookingSearchForm', this.searchForm)
      // this.$router.push('/HotelDetail')
      this.isShowReturn = false
      this.isShowContinue = false
      this.onSearch()
    },
    toLogin () {
      this.$router.push('/login')
    },
    mapHandler ({BMap, map}) {
      console.log(BMap, map)
      if (this.mapCenter.lng && this.mapCenter.lat) {
        // 坐标转换
        let ggPoint = new BMap.Point(this.mapCenter.lng, this.mapCenter.lat)
        let convertor = new BMap.Convertor()
        let pointArr = []
        pointArr.push(ggPoint)
        convertor.translate(pointArr, 3, 5, (data) => {
          if (data.status === 0) {
            let marker = new BMap.Marker(data.points[0])
            map.addOverlay(marker)
            map.setCenter(data.points[0])
          }
        })
      }
    },
    changeDate (val) {
      let checkInDate = new Date(val)
      checkInDate.setDate(checkInDate.getDate() + 1)
      let checkOutDate = checkInDate.Format('yyyy-MM-dd')
      this.searchForm.checkOut = checkOutDate
      this.$refs.checkOutPicker.focus()
    },
    handleScroll () {
      let scrollNum = document.documentElement.scrollTop || document.body.scrollTop
      if (scrollNum > 577) {
        this.isSuckTop = true
        this.selectIndex = 4
      } else {
        this.isSuckTop = false
        this.selectIndex = 1
      }
    },
    handleClick (e) {
      // 获取遮罩层dom
      let domImageMask = document.querySelector('.el-image-viewer__mask')
      if (!domImageMask) {
        return
      }
      if (domImageMask.contains(e.target)) {
        document.querySelector('.el-image-viewer__close').click()
      }
    },
    upSelectBedType (val) {
      this.selectBedType = val
    },
    upSelectRoomName (val) {
      this.selectRoomId = val
    },
    upSelectBreakfastType (val) {
      this.selectBreakfastType = val
    },
    upSelectInvoiceType (val) {
      this.selectInvoiceType = val
    },
    clearFilter () {
      for (let i = 1; i <= 4; i++) {
        let refName = `radioSpan${i}`
        this.$refs[refName].clearVal()
      }
      this.selectBedType = ''
      this.selectRoomId = ''
      this.selectBreakfastType = ''
      this.selectInvoiceType = ''
    },
    isContainBedType (bedInfo) {
      if (!this.selectBedType) {
        return true
      }
      if (!bedInfo) {
        return false
      }
      return this.selectBedType === bedInfo
    },
    isContainCancelType (rates) {
      if (!this.isCancel) {
        return true
      }
      if (!rates || rates.length === 0) {
        return false
      }
      return rates.some(item => item.cancel === 'yes')
    },
    isContainInvoiceType (rates) {
      if (!this.selectInvoiceType) {
        return true
      }
      if (!rates || rates.length === 0) {
        return false
      }
      return rates.some(item => item.invoice === this.selectInvoiceType)
    },
    isContainBreakfastType (rates) {
      if (!this.selectBreakfastType) {
        return true
      }
      if (!rates || rates.length === 0) {
        return false
      }
      for (let i = 0; i < rates.length; i++) {
        let item = rates[i]
        if (this.selectBreakfastType === 1 && item.mealCount > 0) {
          return true
        } else if (this.selectBreakfastType === 2 && item.mealCount === 1) {
          return true
        } else if (this.selectBreakfastType === 3 && item.mealCount === 2) {
          return true
        }
      }
      return false
    },
    getFilterRates (oldRates, item) {
      if (!this.selectBreakfastType && !this.isCancel && !(item.roomId === -1 && this.selectBedType) && !this.selectInvoiceType) {
        return oldRates
      }
      let newRates = []
      for (let i = 0; i < oldRates.length; i++) {
        let rItem = oldRates[i]
        if (this.selectBreakfastType && this.isCancel) {
          if (rItem.cancel !== 'yes') continue
          if (this.selectBreakfastType === 1 && rItem.mealCount > 0) {
            newRates.push(rItem)
          } else if (this.selectBreakfastType === 2 && rItem.mealCount === 1) {
            newRates.push(rItem)
          } else if (this.selectBreakfastType === 3 && rItem.mealCount === 2) {
            newRates.push(rItem)
          }
        } else {
          if (this.selectBreakfastType) {
            if (this.selectBreakfastType === 1 && rItem.mealCount > 0) {
              newRates.push(rItem)
            } else if (this.selectBreakfastType === 2 && rItem.mealCount === 1) {
              newRates.push(rItem)
            } else if (this.selectBreakfastType === 3 && rItem.mealCount === 2) {
              newRates.push(rItem)
            }
          }
          if (this.isCancel && rItem.cancel === 'yes') {
            newRates.push(rItem)
          }
        }
      }
      if (this.selectBedType && item.roomId === -1) {
        if (newRates.length) {
          newRates = newRates.filter(r => r.bedInfo === this.selectBedType)
        } else {
          newRates = oldRates.filter(r => r.bedInfo === this.selectBedType)
        }
      }
      if (this.selectInvoiceType) {
        if (newRates.length) {
          newRates = newRates.filter(r => r.invoice === this.selectInvoiceType)
        } else {
          newRates = oldRates.filter(r => r.invoice === this.selectInvoiceType)
        }
      }
      return newRates
    },
    seeMore () {
      this.selectIndex = '2'
      document.documentElement.scrollTop = 600
      document.body.scrollTop = 600
    },
    toPoint (e) {
      const target = this.$refs[e];
      if (!target || !(target instanceof HTMLElement)) {
        return;
      }
      const elementTop = target.getBoundingClientRect().top + window.pageYOffset;
      // 最终滚动位置：元素顶部 - 预留的100px间距
      const scrollToPosition = elementTop - 100;

      // 平滑滚动到目标位置
      window.scrollTo({
        top: scrollToPosition,
        behavior: 'smooth' // 可选：移除则为瞬间滚动
      });
    },
    toWebSide (url) {
      if (url) {
        if (url.includes('http')) {
          window.open(url, '_blank')
        } else {
          window.open(`http://${url}`, '_blank')
        }
      }
    },
    showImgDialog (imgs, url, type, room) {
      if (type === 1) {
        if (!imgs || !imgs.length || !url) return
        let index = imgs.findIndex(item => item.imageUrl === url)
        this.$refs['hotelImgRef'].init(imgs, index, type)
      } else {
        room.regionId = this.$commonUtil.getRegionBySHotelId(this.hotelInfo.hotelId)
        if (!imgs || !imgs.length || !url) {
          this.$refs['hotelImgRef'].init([], -1, type, room)
        } else {
          let index = imgs.findIndex(item => item.imageUrl === url)
          this.$refs['hotelImgRef'].init(imgs, index, type, room)
        }
      }
    },
    getRoomImgs (roomId) {
      return this.hotelInfo.allImages.filter(item => item.roomId === roomId)
    },
    toCtripPage () {
      let href = `http://hotels.ctrip.com/hotels/${this.hotelInfo.ctripHotelCode}.html?checkin=${this.searchForm.checkIn}&checkout=${this.searchForm.checkOut}&crn=${this.searchForm.room}&adult=${this.searchForm.adult}`
      window.open(href, '_blank')
    },
    getCustomerType () {
      let res = ''
      if (!this.hotelInfo.customerType) return res
      let types = this.hotelInfo.customerType.split(',')
      types.forEach((item, index) => {
        res += `${this.customerTypes[item]}${index < types.length - 1 ? '、' : ''}`
      })
      return res
    },
    expandItem (item) {
      this.$set(this.expandMap, item.roomId, !this.expandMap[item.roomId])
    },
    showIcon (name) {
      if (!this.hotelInfo.hotelFacilities || !this.hotelInfo.hotelFacilities.length) return false
      let facilities = this.hotelInfo.hotelFacilities.map(item => item.facilities.map(f => f.toLowerCase())).flat()
      return facilities.some(item => item.includes(name.toLowerCase()))
    },
    mouseEnter (item) {
      this.showImgDialog(this.getRoomImgs(item.roomId), item.images ? item.images[0] : '', 2, item)
    },
    toHotelDetail (e) {
      let obj = {
        room: this.searchForm.room,
        adult: this.searchForm.adult,
        checkIn: this.searchForm.checkIn,
        checkOut: this.searchForm.checkOut,
        channelId: null,
        regions: [],
        stars: [0],
        price: 0,
        siteType: 0,
        districtName: null,
        bizZoneName: null,
        starRating: null,
        hotelId: e.hotelId
      }
      localStorage.setItem('hotelDetailSearchForm', JSON.stringify(obj))
      window.open('/HotelDetail', '_blank')
    },
    showProductDialog (productInfo) {
      this.$refs['productDialogRef'].init(productInfo)
    }
  }
}
</script>

<style scoped lang="less">
.form-text {
  font-size: 14px;
  margin-bottom: 5px;
  color: #868686;
}

.el-menu--horizontal > .el-menu-item {
  height: 50px;
  line-height: 50px;
}

.menu-item-row {
  /*border: solid 1px #ececec;*/
  padding-top: 20px;
  min-height: 200px;
}

.room-item {
  float: left;
  padding: 15px 0 15px 10px;
  color: #4B5563;
}

.room-item-title {
  color: #4499ff;
  margin-left: 15px;
  font-weight: 600;
}

.room-info-item {
  padding: 15px 0 15px 10px;
}

.oneday-price {
  color: #1e50f0;
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;
}

.price-tab,
.price-tab tr th,
.price-tab tr td {
  border: 2px solid #e3e3e3;
}

.price-tab tr th,
.price-tab tr td {
  width: 50%;
  height: 25px;
  padding-left: 10px;
}

.price-tab {
  margin-top: 10px;
  width: 100%;
  border-collapse: collapse;
}

.box {
  background-color: #fff;
  width: 1180px;
}


/deep/ .el-collapse-item__header {
  border-bottom: solid 1px #dddddd;
}

/deep/ .el-collapse-item__header.is-active {
  color: #0E919B;
  border-bottom-color: #dddddd;
}

/deep/ .el-collapse-item__content {
  padding-bottom: 0;
}

/deep/ .el-dialog {
  border-radius: 7px;
}

/deep/ .el-dialog__header {
  height: 0;
  padding: 0;
}

/deep/ .el-dialog__body {
  padding: 35px;
}

/deep/ .anchorBL {
  display: none;
}

/deep/ .el-popover {
  padding: 0;
  background-color: red;
}

.bookingBtn {
  background-color: #1e50f0;
  color: #FFFEFF;
  font-family: "微软雅黑", serif;
  border-radius: 8px;
  border: none;
  height: 30px;
  line-height: 0;
}

.bookingBtn:hover {
  background-color: #3b69fa;
  color: #FFFEFF;
}

.bookingBtn:focus {
  background-color: #1e50f0;
  color: #FFFEFF;
}

/deep/ .choosed[data-v-33e43f86] {
  border-color: #0FA3AE;
  color: #0FA3AE;
  z-index: 5;
}

.hotel_facilities {
  margin-left: 8px;
}

/deep/ .el-icon-arrow-right {
  color: #44a6ff;
}

.star_box {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  grid-column-gap: 15px;
}

.hotel_star {
  display: flex;
  align-items: center;
  column-gap: 15px;
}

.hotel_introduce_box {
  margin-top: 15px;
  width: 600px;

  display: grid;
  grid-template-columns: max-content 1fr max-content;
  grid-column-gap: 10px;

  font-size: 14px;

  .hotel_desc_text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.hotel_url {
  cursor: pointer;
  margin-top: 15px;
  display: flex;
  align-items: center;
  column-gap: 8px;

  &:hover {
    color: #1e50f0;
  }
}


.hotel_facility_box {
  display: grid;
  grid-template-columns: max-content 1fr;
  align-items: center;
}

.img_box {
  position: relative;

  .img_count {
    position: absolute;
    right: 0;
    bottom: 0;
    border: 1px solid #797979;
    background-color: rgba(0, 0, 0, .3);
    padding: 10px 18px;
    color: #fff;
  }
}

.room_box {
  width: 245px;
  background-color: #fff;
  padding: 4px 20px 2px 4px;
  border-right: 1px solid #ececec;
  border-radius: 8px 0 0 8px;
  padding: 10px 10px 10px 15px;

  .room_img {
    position: relative;
    text-align: center;

    .room_img_count {
      position: absolute;
      right: 19px;
      bottom: 0;
      background-color: rgba(0, 0, 0, .3);
      padding: 2px 8px;
      color: #fff;
      cursor: pointer;
      border-radius: 0 0 8px 0;
    }
  }

  .room_name {
    text-align: left;
    font-weight: bolder;
    font-size: 12px;
    margin-bottom: 6px;
    width: 190px;
    padding-left: 20px;
    line-height: 16px;
  }

  .room_info_box {
    margin-top: 8px;
    color: #999999;
    font-size: 12px;
    line-height: 20px;
    padding-left: 20px;

    span {
      &:not(:last-child) {
        &::after {
          content: '|';
          padding-left: 4px;
        }
      }
    }
  }
}

.room_right_box {
  width: 933px;
  border-radius: 0 8px 0 0;
  background-color: #FFFFFF;

  &.is_center {
    display: flex;
    flex-flow: wrap;
    align-self: center;
  }
}

.rate_box {
  background-color: #FFFFFF;
  overflow: hidden;
  transition: max-height linear .2s;

  .rate_item {
    width: 933px;
    display: grid;
    grid-template-columns: 147px 147px 196px 147px 147px 1fr;
    align-items: center;
    padding: 20px 0 25px 15px;
    min-height: 95px;

    &:not(:last-child) {
      border-bottom: 1px solid #e8e8e8;
    }

    .other_room_name {
      width: 190px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

.more_btn {
  padding: 10px 30px;
  text-align: center;
  color: #2494f6;
  cursor: pointer;
  user-select: none;
  border-top: 1px solid #e8e8e8;
}

.filter_box {
  display: flex;
  align-items: center;
  background-color: #FFFFFF;
  padding: 20px;
  border-radius: 0 0 8px 8px;
  column-gap: 12px;

  & /deep/ .el-checkbox__label {
    color: #565f6c;
    padding-left: 5px !important;
  }

  & /deep/ .el-input__inner {
    background-color: #f3f4f6 !important;
    color: #1e50f0 !important;
    font-weight: 500 !important;
    border-radius: 8px;
  }

  & /deep/ .el-icon-arrow-up:before {
    color: #d1d5db !important;
    font-weight: normal !important;
  }

  & /deep/ .el-icon-circle-close::before {
    color: #d1d5db !important;
    font-weight: normal !important;
  }

  & /deep/ .el-input__inner::placeholder {
    color: #374151 !important;
    font-weight: 500 !important;
  }

  .clear_btn {
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #D1D5DB;
    cursor: pointer;
    user-select: none;
    padding: 8px 20px;
  }

  .cancel_btn {
    background: #f3f4f6;
    border-radius: 8px;
    cursor: pointer;
    user-select: none;
    width: 110px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-weight: 500;
    color: #374151;
    font-size: 14px;

    &.active {
      background: #1e50f0;
      color: #fff;
    }
  }
}

.room_image_box {
  position: relative;
  overflow: hidden;

  .noRoomImg {
    filter: blur(1.5px);
    transform: scale(1.03);
  }

  &::before {
    content: '暂无图片';
    color: #fff;
    font-size: 14px;
    font-family: '苹方';
    font-weight: 600;
    letter-spacing: 1px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-75%, -50%);
    z-index: 99;
  }
}

.image_box {
  position: relative;
  overflow: hidden;

  .noImg {
    filter: blur(3px);
    transform: scale(1.03);
  }

  &::before {
    content: '暂无图片';
    color: #fff;
    font-size: 16px;
    font-family: '苹方';
    font-weight: 600;
    letter-spacing: 1px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 99;
  }
}

.img_main {
  display: grid;
  grid-template-columns: repeat(3, calc(33.3% - 10px));
  grid-template-rows: repeat(2, 230px);
  justify-content: space-between;
  grid-gap: 10px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
  }

  .first_img {
    grid-row-start: 1;
    grid-row-end: 3;
  }
}

.desc_title {
  font-weight: 600;
  color: #000000;
}

.top_hotel_info_box {
  background-color: #FFFFFF;
  padding: 20px;
  display: flex;
  column-gap: 15px;
  border-radius: 8px;

  .left {
    width: 640px;
  }

  .right {
    width: 485px;
    display: flex;
    column-gap: 10px;
    position: relative;

    .img_count {
      position: absolute;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, .5);
      padding: 5px 9px;
      color: #fff;
      border-radius: 0 0 8px 0;
    }

    img {
      width: 100%;
      height: 110px;
      border-radius: 8px;
      object-fit: cover;
      cursor: pointer;

      &:hover {
        transform: scale(1.1);
        transition: all .3s;
      }
    }

    .main_img {
      width: 285px;
      overflow: hidden;
      border-radius: 8px;

      img {
        height: 230px;
      }
    }

    .sub_img {
      overflow: hidden;
      border-radius: 8px;
      width: 190px;
    }
  }

  .hotel_desc_text {
    width: 500px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .facility_box {
    display: flex;
    align-items: center;
    column-gap: 15px;
    margin-top: 15px;

    .facility_item {
      text-align: center;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .08);
      padding: 8px;
      border-radius: 8px;

      i {
        font-size: 28px;
        color: #3b82f6;
      }
    }
  }
}

.new_form_box {
  background-color: #FFFFFF;
  margin-top: 20px;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  column-gap: 20px;

  .form_title {
    color: #374151;
    margin-bottom: 8px;
  }

  & /deep/ .el-input__inner {
    border-radius: 12px !important;
    border-color: #D1D5DB !important;
  }
}

.to_ctrip_btn {
  cursor: pointer;
  color: #1e50f0;
  text-decoration: underline;
}

.rooms_content {
  box-shadow: 0 2px 2px #eaeaea;
  overflow: hidden;
  background-color: #FFFFFF;
}

.cancel_policy {
  display: flex;
  align-items: center;
  column-gap: 5px;
  background-color: #dcfce7;
  color: #357c50;
  border-radius: 50px;
  width: 80px;
  text-align: center;
  padding: 5px 0 5px 5px;
  margin-bottom: 5px;
}

.no_cancel_policy {
  display: flex;
  align-items: center;
  column-gap: 5px;
  background-color: #fee2e2;
  color: #9f7878;
  border-radius: 50px;
  width: 80px;
  text-align: center;
  padding: 5px 0 5px 5px;
}

.recommend_hotel_box {
  display: flex;
  column-gap: 25px;
  padding: 20px;
  cursor: pointer;

  .item {
    width: 363px;
    min-height: 330px;
    border-radius: 8px;
    border: 1px solid #E5E7EB;
    padding: 20px;

    .hotel_name {
      margin-top: 15px;
      font-weight: 600;
      margin-bottom: 15px;
    }

    .hotel_star {
      display: grid;
      grid-template-columns: repeat(2, max-content);
      align-items: center;
      grid-column-gap: 6px;
      font-size: 13px;
      color: #8c8c8c;
    }

    .hotel_img {

      width: 100%;
      height: 192px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 8px;
      }

      .no_img {
        width: 100%;
        height: 200px;
        position: relative;
        border-radius: 8px;
        overflow: hidden;

        img {
          filter: blur(1.5px);
          transform: scale(1.03);
        }

        &::before {
          content: '暂无图片';
          color: #fff;
          font-size: 14px;
          font-family: '苹方';
          font-weight: 600;
          letter-spacing: 1px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 99;
        }
      }
    }
  }
}

.tab_box {
  background-color: #FFFFFF;
  margin-top: 20px;
  border-radius: 8px 8px 0 0;
  padding: 20px;
  display: flex;
  column-gap: 15px;
  font-size: 14px;

  .tab_item {
    cursor: pointer;
    user-select: none;
    font-weight: 600;

    &.active {
      color: #4488f6;
      font-weight: 600;
    }
  }
}

.pkg_box {
  margin-left: -2px;
  margin-bottom: 5px;
  color: #3b69fa;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/booking/HotelDetail.vue